import { createApp } from 'vue'
import Vuex from 'vuex'
const app = createApp({})

app.use(Vuex)

export default new Vuex.Store({
  state: {
    model: null
  },
  getters: {
    model: state => state.model
  },
  mutations: {
    setModel (state, model) {
      state.model = model
    }
  },
  action: {
    setModel (context, model) {
      context.commit('setModel', model)
    }
  }
})
